import { useIsPageOwner } from './useIsPageOwner';
import { usePageOwnerIdentityStore } from '../store/pageOwnerIdentityStore';
import { useGroupMemberState } from './useApi/useGroupMember';
import { canShowGroupMemberList } from '../util/visibility/groupMemberVisibility';
import type { ResourceScope } from '../util/scopedResource';

/** Group Member 목록 canShow (Indexing 모달 등) */
export const useCanShowGroupMemberList = (): boolean => {
  const isOwner = useIsPageOwner();
  const pageOwnerAui = usePageOwnerIdentityStore((s) => s.pageOwner?.aui);
  const { listOwnerAui, listScope, status } = useGroupMemberState();
  const currentScope: ResourceScope = isOwner ? 'owner' : 'public';

  return canShowGroupMemberList({
    pageOwnerAui,
    listOwnerAui,
    listScope,
    currentScope,
    status,
  });
};
